export class QualifiedTeacherListLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            sno: lang.academy[2],
            name: lang.academy[120],
            surname: lang.academy[121],
            telephone: lang.academy[122],
            email: lang.academy[123],
            company: lang.academy[129],
            skills: lang.academy[139],
            qualificationDate: lang.academy[127],
            qualificationStatus: lang.academy[219],
            close: lang.academy[98],
            save: lang.academy[221],
            action: lang.academy[7],
            erase: lang.academy[154],
            modify: lang.academy[152],
            view: lang.general[3],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            clickhere: lang.academy[97],
            importTitle: lang.academy[203],
            createTeacher: lang.academy[151],
            fiscalCode: lang.academy[130],
            taxCode: lang.academy[131],
            address: lang.academy[132],
            city: lang.academy[124],
            province: lang.academy[217],
            zipcode: lang.academy[133],
            curriculumMaterial: lang.academy[134],
            personalDocumentation: lang.academy[135],
            contract: lang.academy[136],
            generalNotes: lang.academy[137],
            imagefiles: lang.academy[138],
            requiredField: lang.academy[115],
            editTeacher: lang.academy[204],
            catalogueCode: lang.academy[19],
            courseTitle: lang.academy[3],
            category: lang.academy[63],
            scopeofTeaching: lang.academy[218],
            basicLevel: lang.academy[142],
            currentLevel: lang.academy[143],
            available: lang.academy[144],
            addskills: lang.academy[140],
            selectCode: lang.academy[222],
            hourlyCost: lang.academy[215],
            attachments: lang.academy[216],
            notes: lang.academy[23],
            state: lang.academy[202],
            identityPapers: lang.academy[205],
            qualifiedTeachers: lang.academy[119],

        }

    }

    lang() {
        return this.variables;
    }

}

export class QualifiedTeacherViewLang {

    variables  = null;

    constructor(lang) {

        this.variables = {
            sno: lang.academy[2],
            name: lang.academy[120],
            surname: lang.academy[121],
            telephone: lang.academy[122],
            email: lang.academy[123],
            company: lang.academy[129],
            skills: lang.academy[139],
            qualificationDate: lang.academy[127],
            qualificationStatus: lang.academy[219],
            close: lang.academy[98],
            save: lang.academy[221],
            action: lang.academy[7],
            erase: lang.academy[154],
            modify: lang.academy[152],
            view: lang.general[3],
            selectColumns: lang.general[9],
            selectAll: lang.general[10],
            activeColumns: lang.general[11],
            exportCsv: lang.general[13],
            exportPdf: lang.general[14],
            exportExcel: lang.general[15],
            print: lang.general[16],
            clickhere: lang.academy[97],
            importTitle: lang.academy[203],
            createTeacher: lang.academy[151],
            fiscalCode: lang.academy[130],
            taxCode: lang.academy[131],
            address: lang.academy[132],
            city: lang.academy[124],
            province: lang.academy[217],
            zipcode: lang.academy[133],
            curriculumMaterial: lang.academy[134],
            personalDocumentation: lang.academy[135],
            contract: lang.academy[136],
            generalNotes: lang.academy[137],
            imagefiles: lang.academy[138],
            requiredField: lang.academy[115],
            editTeacher: lang.academy[204],
            catalogueCode: lang.academy[19],
            courseTitle: lang.academy[3],
            category: lang.academy[63],
            scopeofTeaching: lang.academy[218],
            basicLevel: lang.academy[142],
            currentLevel: lang.academy[143],
            available: lang.academy[144],
            addskills: lang.academy[140],
            selectCode: lang.academy[222],
            hourlyCost: lang.academy[215],
            attachments: lang.academy[216],
            notes: lang.academy[23],
            generalData: lang.academy[16],
            coursesDelivered: lang.academy[207],
            dynamicEvaluation: lang.academy[208],
            qualifiedTeacherView: lang.academy[206],
            teacherDetails: lang.academy[209],
            state: lang.academy[202],
            identityPapers: lang.academy[205],
            catalogCode: lang.academy[1],
            coursesCategory: lang.academy[4],
            durationHours: lang.academy[5],
            endDate: lang.academy[41],
            startDate: lang.academy[40],
            customer: lang.academy[43],
            status: lang.academy[42],
            courseEvaluation: lang.academy[212],
            instances: lang.academy[39],
            generalResume: lang.academy[32],
            totalHours: lang.academy[33],
            totalAttendies: lang.academy[34],
            totalCourseScore: lang.academy[36],
            averageTeacherScore: lang.academy[37],
            attendies: lang.academy[44],
            hour: lang.academy[213],
            courseScore: lang.academy[47],
            teacherScore: lang.academy[48],
            qualifiedTeachers: lang.academy[119],
           
        }

    }

    lang() {
        return this.variables;
    }

}
